import {
  mainTextWhite,
  mainTextGray,
  blueMain,
  headerHeight,
  blackMainHover,
  grayButton,
  blackMainLightHover,
  navbarDivider,
} from '../../../theme';

const blueProfile = '#76a6fa';
const whiteText = '#f3f3f3';
const grayButtonHoverProfile = '#4c4c4c';

const styles = () => ({
  root: {
    position: 'relative',
    zIndex: 1000,
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
  },
  userInfo: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    padding: '16px 16px 0 16px',
    alignItems: 'center',
  },
  textInfo: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 10,
    width: 180,
    '& p': {
      fontSize: 14,
      wordWrap: 'break-word',
    },
    '& p:first-child': {
      fontSize: 20,
      marginBottom: 5,
    },
  },
  nav: {
    color: mainTextGray,
    fontWeight: 400,
    borderBottom: '3px solid transparent',
    backgroundColor: 'transparent',
    height: headerHeight,
    '&:hover': {
      color: mainTextWhite,
      backgroundColor: blackMainHover,
    },
    '& .MuiSvgIcon-root': {
      transition: 'transform 110ms,fill 110ms,-webkit-transform 110ms',
    },
  },
  open: {
    color: mainTextWhite,
    backgroundColor: blackMainHover,
    '& .MuiSvgIcon-root': {
      transform: 'rotate(180deg)',
    },
  },
  active: {
    '&:after': {
      position: 'absolute',
      content: '""',
      bottom: -2,
      left: 0,
      right: 0,
      borderBottom: `3px solid ${blueMain}`,
    },
  },
  dropdownContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  dropdown: {
    position: 'absolute',
    backgroundColor: blackMainHover,
    boxShadow: '0 4px 8px 0 rgb(0 0 0 / 50%)',
    width: 270,
    right: 0,
    padding: 0,
    color: whiteText,
    '& .MuiListItem-root span': {
      fontSize: 14,
      display: 'inline',
      color: blueProfile,
      '&:hover': {
        borderBottom: `1px solid ${blueProfile}`,
      },
    },
  },
  manageDropdownContainer: {
    position: 'relative',
    '&:before': {
      position: 'absolute',
      top: '50%',
      left: 0,
      display: 'block',
      width: 1,
      height: 24,
      backgroundColor: navbarDivider,
      transform: 'translateY(-50%)',
      content: '""',
    },
  },
  manageDropdownButton: {
    marginLeft: 20,
  },
  manageDropdown: {
    right: 0,
    boxShadow: '0 4px 8px 0 rgb(0 0 0 / 50%)',
    zIndex: 8000,
    position: 'absolute',
    backgroundColor: blackMainHover,
    width: 200,
    padding: 0,
    color: mainTextGray,
    '& a:hover': {
      color: mainTextWhite,
      backgroundColor: blackMainLightHover,
    },
    '& span': {
      fontSize: 14,
    },
  },
  profile: {
    '& > .MuiButton-root': {
      minWidth: 50,
      maxWidth: 50,
    },
  },
  icon: {
    color: mainTextWhite,
    fontSize: 20,
  },
  user: {
    position: 'relative',
    width: 45,
    minWidth: 45,
    height: 45,
    overflow: 'hidden',
    borderRadius: '50%',
    display: 'flex',
    background: grayButton,
    '& img': {
      width: '100%',
      height: 'auto',
      objectFit: 'cover',
    },
    '& svg': {
      width: 45,
      alignSelf: 'center',
    },
  },
  logOut: {
    width: 'inherit',
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'start',
    padding: '10px 16px',
    background: grayButton,
    color: mainTextWhite,
    fontWeight: 'normal',
    '&:hover': {
      background: grayButtonHoverProfile,
    },
  },
  links: {
    padding: '16px 0px',
  },
});

export default styles;
